var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('h1',[_vm._v("Login")])])],1)],1),_c('login-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }